import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/dental/PageHero";
import { SPA_SERVICES } from "../data/site";
import Button from "../components/dental/Button";
import {SpaServicesSection} from "../components/dental/SpaServicesSection";

const SpaServicesPage = () => (
  <>
    <PageHero
      subtitle="Exclusive"
      title="Spa Services"
      breadcrumb="Exclusive Spa Services"
      image="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/a8a4c32e-21fe-4cac-983a-82c5612f4090.jpg"

    />

    {/* Intro */}
    {/* <section className="bg-[#FBF8F1] py-10 border-b border-[#B79A68]/20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#B79A68]" />
          <span className="text-[#7D6A42] text-[10px] uppercase tracking-[0.4em]">Curated for You</span>
          <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#B79A68]" />
        </div>
        <p className="text-[#4E5750]/80 text-base md:text-lg leading-relaxed">
          Indulge in carefully curated wellness rituals that complement your dental visit and leave you feeling truly
          restored. Each treatment is delivered in a private suite by our licensed therapists — with no surgery, no
          downtime, and results you can see.
        </p>
      </div>
    </section> */}

    {/* Services */}
    <section className="bg-[#FBF8F1] py-10">
      <SpaServicesSection services={SPA_SERVICES} />
    </section>

    

    {/* Features strip */}
    {/* <section className="bg-[#2a1f12] py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {FEATURES.map((f) => (
              <div key={f.title} className="flex flex-col items-center text-center gap-3">
                <div className="text-[#B79A68]">{f.icon}</div>
                <h4 className="font-cinzel text-[11px] text-[#e8d4a0] uppercase tracking-[0.25em]">{f.title}</h4>
                <p className="text-[#B79A68]/70 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
        </div>
      </div>
    </section> */}

    {/* Booking CTA */}
    <section className="relative bg-[#fdfcf8] py-10 overflow-hidden">
      {/* Subtle background decoration */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.035]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #B79A68 0px, #B79A68 1px, transparent 1px, transparent 40px)",
        }}
      />
      <div className="relative max-w-2xl mx-auto px-6 text-center">
        <p className="font-script text-4xl gold-gradient-text mb-1">Ready to Indulge?</p>
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#B79A68]" />
          <span className="text-[#7D6A42] text-[10px] uppercase tracking-[0.4em]">Your Ritual Awaits</span>
          <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#B79A68]" />
        </div>
        <p className="text-[#4E5750]/75 text-sm leading-relaxed mb-9">
          Schedule a complimentary consultation and we'll create a personalised treatment plan tailored to your goals
          and timeline. Most services can be combined with a dental visit.
        </p>
        <Button to="/contact">Book A Consult</Button>
      </div>
    </section>
  </>
);

export default SpaServicesPage;
